export const FETCH_COURIERS_REQUESTED = 'FETCH_COURIERS_REQUESTED';
export const FETCH_COURIERS_SUCCEEDED = 'FETCH_COURIERS_SUCCEEDED';
export const SORT_COURIERS_REQUESTED = 'SORT_COURIERS_REQUESTED';
export const SORT_COURIERS_SUCCEEDED = 'SORT_COURIERS_SUCCEEDED';
